<template>
    <div>
        <v-chip @click="$emit('click')" dark :color="color" style="border: 1px solid #555" class="color-chip">
            <div>
                <span v-if="selected" class="selected-color"></span>
                <slot v-if="!colors_array"></slot>
                <div class="color-indicator">
                    <span v-for="(color,index) in colors_array" :class="{'span-overflow': index > 0}" :style="{'background-color': color}"></span>
                </div>
            </div>
        </v-chip>
    </div>
</template>
<script>
    import {VChip} from 'vuetify/lib/components/VChip'
    export default {
        extends: VChip,
        props:['color_info', 'selected'],
        data:() => {
            return{
                colors_array:null
            }
        },
        mounted(){
            if(this.color_info){
                this.colors_array = [];
                if(this.color_info.hex_value) this.colors_array.push(this.color_info.hex_value);
                if(this.color_info.secondary_hex_value) this.colors_array.push(this.color_info.secondary_hex_value);
            }

        }
    }
</script>
<style lang="scss">
    .color-indicator{
        display: flex;
        overflow: visible !important;
        justify-content: center;
        position: relative;
        span{
            min-height: 20px;
            min-width: 20px;
            border-radius: 10px;
        }
        .span-overflow{
            margin-left: -5px;
        }
    }
    .color-chip{
        overflow: visible !important;
    }
    .selected-color{
        min-width: 20px;
        min-height: 20px;
        background-color: black;
        position: absolute;
        top: -5px;
        right: -5px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:after{
            content: "\F012C";
            display: inline-block;
            font: normal normal normal 24px/1 "Material Design Icons";
            font-size: inherit;
            text-rendering: auto;
            line-height: inherit;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
    }
</style>
